<template>
  <div class="coproducer-products">
    <bp-table-header
      :total="pagination.count"
      @refresh="refresh"
      @open-filter="filter = true"
    >
      <template #input>
        <bp-input
          v-model="search"
          size="md"
          placeholder="Buscar produto"
          pre-icon="fa-light fa-search"
          :delay="300"
          @change="refresh"
        />
      </template>
    </bp-table-header>

    <div v-if="loading" class="centering pt-6">
      <b-spinner variant="primary" style="width: 3rem; height: 3rem;" />
    </div>

    <template v-else-if="myCoproducers.length">
      <div class="row mt-6">
        <div
          class="col-12 mb-6"
          :class="{ 'col-xl-2 col-lg-2half col-sm-6': gallery }"
          v-for="coproduction in myCoproducers"
          :key="coproduction.id"
        >
          <product-card
            :is-gallery="gallery"
            :id="coproduction.id"
            :status="coproduction.status"
            :product="coproduction.product"
            @refresh="refresh"
          />
        </div>
      </div>

      <div class="d-flex justify-content-end">
        <bp-paginator
          v-model="page"
          :pagination="pagination"
          @change-page="dispatch"
        />
      </div>
    </template>

    <div v-else class="text-center">
      <img
        class="d-block my-9 mx-auto"
        src="@/assets/images/home/welcome.svg"
      />
      <h5>Não foram encontrados produtos</h5>
    </div>
  </div>
</template>
<script>
import ProductCard from "./CoproducerProductCard";

import { clearObject } from "@/functions/helpers";
import { mapState } from "vuex";

export default {
  components: { ProductCard },
  data() {
    return {
      loading: false,
      page: 1,
      search: ""
    };
  },
  computed: {
    ...mapState("user", ["preferences", "myCoproducers", "pagination"]),
    gallery() {
      return this.preferences.product_list === "gallery";
    }
  },
  methods: {
    refresh() {
      this.page = 1;
      this.dispatch();
    },
    dispatch(offset) {
      this.loading = true;

      this.$store
        .dispatch(
          "user/getMyCoproducer",
          clearObject({ offset, search: this.search })
        )
        .catch(() => {
          this.$message.error("Erro ao recuperar produtos");
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  mounted() {
    this.dispatch();
  }
};
</script>
